var render = function render(){var _vm=this,_c=_vm._self._c;return _c('in-out-stock',{attrs:{"stock-type":"in"}})
}
var staticRenderFns = []

export { render, staticRenderFns }